import React from 'react'
import Lpntable from './Components/Lpn-table'
import Header from '../../../../Components/Header'

const PurchaseAnalytics = () => {
  return (
        <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>
        <Header />
        <Lpntable />
        {/* <Footer /> */}
    </div>
  )
}

export default PurchaseAnalytics